import React, { useState, useEffect } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import DriverService from '../../services/DriverService';
import axios from 'axios';

function NhapChuyenBuuChinhComponent() {
  const [formData, setFormData] = useState({
    ma_chuyen: '',
    ma_chuyen_noc: ''
  });
  const [maChuyenNOCList, setMaChuyenNOCList] = useState([]); // Trạng thái cho danh sách mã chuyến NOC

  useEffect(() => {
    // Gọi API để lấy danh sách mã chuyến NOC khi component được render
    const fetchMaChuyenNOC = async () => {
      try {
        const data = await DriverService.getMaChuyenNOC();
        setMaChuyenNOCList(data); // Cập nhật danh sách mã chuyến NOC vào state
      } catch (error) {
        alert(error.message);
      }
    };
    fetchMaChuyenNOC();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === 'ma_chuyen' && value !== '') {
      updatedValue = updatedValue.replace(/[-.]/g, '_').trim().replace(/\s+/g, ' ').toUpperCase();
      if (!updatedValue.includes("CX")) {
        alert("Mã chuyến xe phải có CX");
        updatedValue = "CX" + updatedValue;
      }
    }

    // Cập nhật formData
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: updatedValue
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.ma_chuyen === '') {
      const userConfirmed = window.confirm("Bạn xác nhận chuyến xe này không có mã chuyến đúng không?");
      if (!userConfirmed) return;
    }

    try {
      const response = await DriverService.submitNhapChuyenBuuChinh(formData);
      alert(response.data.message || 'Dữ liệu đã được lưu thành công!');
      console.log(response);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <Container fluid id="container_nhap_tt_tai_xe">
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="ma_chuyen">
          <Form.Label>Mã Chuyến</Form.Label>
          <Form.Control
            type="text"
            name="ma_chuyen"
            value={formData.ma_chuyen}
            onChange={handleChange}
            placeholder="Nhập mã chuyến (bắt buộc có CX)"
          />
        </Form.Group>
        
        <Form.Group controlId="ma_chuyen_noc">
          <Form.Label>Mã Chuyến NOC (tùy chọn)</Form.Label>
          <Form.Control
            as="select"
            name="ma_chuyen_noc"
            value={formData.ma_chuyen_noc}
            onChange={handleChange}
          >
            <option value="">-- Chọn mã chuyến NOC --</option>
            {maChuyenNOCList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.id}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Button variant="primary" type="submit" style={{marginTop: '15px'}}>
          Lưu Thông Tin
        </Button>
      </Form>
    </Container>
  );
}

export default NhapChuyenBuuChinhComponent;
